import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { config } from 'config';
import * as moment from 'moment/moment';


const API_BASE_URL = config.apiBaseUrl[process.env.NODE_ENV];

@Injectable()
export class ServiceInterface {

    constructor(private _http: HttpClient) {}

    async getList(apiName):Promise<any[]> {
        var newdate = moment(new Date()).format('MMDDYYYY_hhmmss');
        var resultMap: any[];
        try {
            resultMap = await this._http.get(API_BASE_URL + apiName+ "?dt=" + newdate).map((response:any) => {
                let result = response.data;
                return result;
            }).toPromise();
        } catch (err) {
            console.log('xhr error!', err);
            throw err;
        }
        return resultMap;
    }

    async get(apiName): Promise<any> {
        var newdate = moment(new Date()).format('MMDDYYYY_hhmmss');
        var resultMap: any;
        try {
            resultMap = await this._http.get(API_BASE_URL + apiName+ "?dt=" + newdate).map((response:any) => {
                let result = response.data;
                return result;
            }).toPromise();
        } catch (err) {
            console.log('xhr error!', err);
        }
        return resultMap;
    }

    async post(apiName,model): Promise<any> {
        var resultMap: any;
        try {
            resultMap = await this._http.post(API_BASE_URL + apiName,model).map((response:any) => {
                let result = response.data;
                return result;
            }).toPromise();
        } catch (err) {
            console.log('xhr error!', err);
        }
        return resultMap;
    }
}


// WEBPACK FOOTER //
// ./src/services/service.interface.ts